import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgxFloatUiPlacements } from 'ngx-float-ui';
import { PopperToolTipComponent } from '../../../../popper/components/popper-tool-tip/popper-tool-tip.component';
import { ExternalLinkService } from '../../../../common/services/external-link.service';

@Component({
    selector: 'ui-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: true,
  imports: [PopperToolTipComponent]
})
export class FooterComponent implements OnInit {
  public popperPlacement: NgxFloatUiPlacements = NgxFloatUiPlacements.TOP;

  constructor(public externalLinkService: ExternalLinkService) { }

  ngOnInit(): void {
  }
}
